angular.module('tradersyard').service('GraphParticipantService', [
    '$rootScope',
    'graph-participant-factory',
    'WebSocket',
    function ($scope, Api, $socket) {
        /**
         *  @type {Object}
         */
        var Services = {};

        /**
         *  @type {Function}
         */
        function Service(id, entry) {
            var service = this;

            function Success(response, action) {
                if (response.data.state === 0) {
                    switch (action) {
                        case 'Query':
                            return response.data.data.length > 0;

                        default:
                            return true;
                    }
                } else {
                    return false;
                }
            }

            function Add(participant) {
                ++service.Let;
                ++service.Count;

                service.Data.unshift(participant);

                return service;
            }

            // ToDo: Cannot read property 'id' of undefined
            function Del(id) {
                if (service.Let > 0) --service.Let;

                angular.forEach(service.Data, function (participant, i) {
                    if (parseInt(participant.id) === parseInt(id)) {
                        service.Data.splice(i, 1);

                        if (service.Count > 0) --service.Count;
                    }
                });

                return service;
            }

            function Concat(data) {
                service.Data = service.Data.concat(data);
                return service;
            }

            function Digest() {
                if (!$scope.$$phase) {
                    $scope.$digest();
                }

                return service;
            }

            function SortQuery(order) {
                if (service.Lock === 0) {
                    service.Lock = 1;
                    service.Page = 1;
                    service.Order = order;

                    Api.entry(service.Entry, service.Id)
                        .query({
                            params: {
                                limit: 25,
                                order: service.Order,
                                page: service.Page,
                                let: service.Let,
                            },
                        })
                        .then(function (response) {
                            if (Success(response, 'Query') === true) {
                                service.Data = response.data.data;
                                service.Lock = 0;
                                Digest();
                            }
                        });
                }
            }

            function Query(next) {
                if (service.Lock === 0) {
                    service.Lock = 1;
                    ++service.Page;

                    Api.entry(service.Entry, service.Id)
                        .query({
                            params: {
                                limit: 25,
                                order: service.Order,
                                page: service.Page,
                                let: service.Let,
                            },
                        })
                        .then(function (response) {
                            if (Success(response, 'Query') === true) {
                                Concat(response.data.data);
                                service.Lock = 0;
                                Digest();
                            }

                            if (next) next();
                        });
                }
            }

            function Join(id, guid, call) {
                service.Guid.push('J-' + guid);
                Api.entry(service.Entry, service.Id)
                    .join({
                        headers: {
                            'X-Ph-Guid': 'J-' + guid,
                        },
                    })
                    .then(function (response) {
                        if (Success(response) === true) {
                            Add(response.data.data);
                            if (call) call();
                            Digest();
                        }
                    });
            }

            function Leave(id, guid, call) {
                service.Guid.push('L-' + guid);
                Api.entry(service.Entry, service.Id)
                    .leave({
                        headers: {
                            'X-Ph-Guid': 'L-' + guid,
                        },
                    })
                    .then(function (response) {
                        if (Success(response) === true) {
                            Del(id);
                            if (call) call();
                            Digest();
                        }
                    });
            }

            function Expire(id, expire, call) {
                Api.entry(service.Entry, service.Id)
                    .expire(id, {
                        expired_at: expire,
                    })
                    .then(function (response) {
                        if (Success(response) === true) {
                            if (call) call();
                        }
                    });
            }

            function Remove(id, call) {
                Api.entry(service.Entry, service.Id)
                    .remove(id)
                    .then(function (response) {
                        if (Success(response) === true) {
                            if (call) call();
                        }
                    });
            }

            $socket.on('participant:join', function (data) {
                // console.log(data);
                if (data.place.name === service.Entry && parseInt(data.place.id) === parseInt(service.Id)) {
                    var index = service.Guid.indexOf(data.guid);

                    if (index === -1) {
                        Add(data.node);
                        Digest();
                    } else {
                        service.Guid.splice(index, 1);
                    }
                }
            });

            // ToDo: Cannot read property 'id' of undefined
            $socket.on('participant:leave', function (data) {
                //console.log(data);
                if (data.place.name === service.Entry && parseInt(data.place.id) === parseInt(service.Id)) {
                    angular.forEach(service.Data, function (participant, i) {
                        if (parseInt(participant.id) === parseInt(data.node.id)) {
                            var index = service.Guid.indexOf(data.guid);

                            if (index === -1) {
                                Del(data.node.id);
                                Digest();
                            } else {
                                service.Guid.splice(index, 1);
                            }
                        }
                    });
                }
            });

            angular.extend(this, {
                Query: Query,
                SortQuery: SortQuery,
                Join: Join,
                Leave: Leave,
                Expire: Expire,
                Remove: Remove,
                Id: id,
                Entry: entry,
                Count: 0,
                Guid: [],
                Data: [],
                Let: 0,
                Lock: 0,
                Page: 0,
                Order: {
                    field: 'created_at',
                    sort: 'desc',
                },
            });
        }

        function Encode(id, entry) {
            return [entry ? entry : 'group', id].join('.');
        }

        function Get(id, entry) {
            var room = Encode(id, entry);

            if (Services[room] === undefined) {
                Services[room] = new Service(id, entry ? entry : 'user');
                // Services[room].Query();
            }

            return Services[room];
        }

        /**
         *  @type {Object}
         */
        this.Get = Get;
    },
]);
